import useAxiosFunction from 'hooks/useAxiosFunction';
import React, { useEffect, useState } from 'react'

const DropdownView = (props) => {
    const { name, parentId, urlfetch, options, valueId, labelId, detail, ...rest } = props
    const [respax, errax, loadingax, fetchax] = useAxiosFunction();
    const [myoptions, setMyoptions] = useState(options)
    const nested = detail && parentId ? true : false
    useEffect(() => {
        if (respax?.data) {
            setMyoptions(respax?.data)
        }
    }, [respax])

    useEffect(() => {
        setMyoptions(options)
    }, [options])

    useEffect(() => {
        if (nested && urlfetch) {
            const urltofetch = detail?.[parentId] ? urlfetch + "/" + detail?.[parentId] : ""
            if (urltofetch) {
                fetchax({ method: "GET", url: urltofetch, auth: true })
            }
        }
    }, [])

    let val = detail?.[name]
    const res = myoptions.filter((item) => {
        return item?.[valueId] === val;
    })
    const myval = res[0]?.[labelId]

    return (
        name && detail?.[name] && val && myoptions && <>{myval}</>
    )
}

DropdownView.defaultProps = {
    name: "",
    label: "",
    placeholder: "",
    options: [],
    valueId: "",
    labelId: "",
}
export default DropdownView
